import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  OnChanges,
  SimpleChanges,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/core/services/api.service';
import { DataService } from 'src/app/core/services/data.service';
import * as async from 'async';
import * as moment from 'moment';
import { File as CustomFile } from 'src/app/shared/models/files';
import { SuperColumn, SuperTableComponent, TranslateService } from '@devinforius/super-compos-17';
import { Global_Class } from '../../../../../../../shared/models/global';
import { saveAs } from 'file-saver';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { FileSelectEvent, FileUpload } from 'primeng/fileupload';
import { IGlobalElements } from 'src/app/shared/models/common/IGlobalElements';
import { IFile } from '@devinforius/i-viewer';
import { IViewerConfigService } from 'src/app/core/services/iviewer.service';
import { IViewerConfig } from '@devinforius/i-viewer/lib/models/i-viewer-config';
import { AreaDropEvent, DroppableArea } from '@devinforius/i-essentials/lib/interfaces';
import { FileUtil } from '@shared/utils';

@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss'],
})
export class FilesComponent implements OnInit, OnChanges {
  @ViewChild('superTableFiles') public superTableFiles: SuperTableComponent;
  @Input() set rights(value) {
    this.fileRights = value;
    if (value && value.files.edit) {
      this.filesMenu = [
        {
          label: this.translater.translate('btn.modify'),
          command: () => {
            window.setTimeout(() => {
              this.openModification = true;
              const index = this.files.map((x) => x.id).indexOf(this.fileClicked.id);
              this.selectedFile = this.files[index];
              this.formFilesModification.patchValue({
                id: this.selectedFile.id,
                description: this.selectedFile.description,
                annexeNumero: this.selectedFile.annexeNumero,
                OrdreAffichage: this.selectedFile.OrdreAffichage,
                annexe:
                  this.selectedFile.extension === 'pdf' && !this.selectedFile.modeleId
                    ? this.selectedFile.annexeNumero
                      ? true
                      : false
                    : false,
                visibleDelibeWeb: this.selectedFile.visibleDelibeWeb,
                visibleDelibeWebCitoyen: this.selectedFile.visibleDelibeWebCitoyen,
              });
            }, 500);
          },
        },
      ];
    } else {
      this.filesMenu = [];
    }
  } //* the rights to add/delete,... files
  public fileRights;
  @Input() files; //* the files +> Will be given from the parent component
  @Input() pointId; //* the id of the point
  @Input() meeting = null; //* the meeting of the parent component (may be null if coming form a point)
  @Input() point = null; //* the point of the parent component (may be null if coming form a meeting)
  @Input() hasLoaded: boolean = true;
  @Input() createUpdatePoint: boolean = false;
  @Output() emitSuccessUpload: EventEmitter<boolean> = new EventEmitter();

  public fileUploadChooseLabel; //* labels displayed on the primeNG component fileUpload
  public fileUploadUploadLabel; //* labels displayed on the primeNG component fileUpload
  public fileUploadCancelLabel; //* labels displayed on the primeNG component fileUpload
  public currentFileForViewer: IFile | null = null;

  public count: number = 0; //* Will be used to have a count for the amount of files uploaded
  public globalElement: Global_Class;

  public columnsFiles: Array<SuperColumn> = [];
  public actions: Array<any> = []; //* forselection list of actions
  public filesMenu: MenuItem[] = []; //* list of actions to be done with the blue table row menu ...

  public openModification: boolean = false; //* boolean used to display or hide the modification modal
  public fileClicked = null; //* The file on which the used clicked !== from 'selectedFile' to avoid crash
  public selectedFile = null; //* the file of the selected row !== from 'fileClicked' to avoid crash
  public formFilesModification: UntypedFormGroup = new UntypedFormGroup({
    id: new UntypedFormControl(null),
    description: new UntypedFormControl(null, Validators.required),
    annexeNumero: new UntypedFormControl(),
    annexe: new UntypedFormControl(),
    OrdreAffichage: new UntypedFormControl(),
    visibleDelibeWeb: new UntypedFormControl(),
    visibleDelibeWebCitoyen: new UntypedFormControl(),
  });
  public blobViewer: any;
  public modalPdfViewer: boolean = false;
  public currentPage: number = 1;
  public confirmDialogBool: boolean = false;
  public itemsUploaded: any;
  public uploader: any;
  public globalConfig = JSON.parse(sessionStorage.getItem('globalConfig'));
  public notifyUserSubscription: Subscription;
  public currentFileToOpen: any;
  public uploadedFilesFromDragAndDrop: File[] = [];
  public isFileOverComponent: boolean = false;
  maxFileSize: number = 104857600; // 100Mo
  MaxFilesSize: number = 314572800; // 300Mo
  public pdfViewerConfig: IViewerConfig;

  public readonly droppableAreas = signal<DroppableArea[]>([
    {
      identifier: 1,
      text: 'Fichier(s) associée(s)',
    },
    {
      identifier: 2,
      text: 'Fichier(s) annexe(s)',
    },
  ]);

  constructor(
    private translater: TranslateService,
    public routing: Router,
    private spinner: NgxSpinnerService,
    public api: ApiService,
    private toastr: ToastrService,
    private dataService: DataService,
    public confirmationService: ConfirmationService,
    private iViewerService: IViewerConfigService
  ) {}

  ngOnInit(): void {
    this.dataService.getGlobalElements.subscribe((res: IGlobalElements) => {
      this.globalElement = new Global_Class(res);
      if (this.globalElement.isLoaded()) {
        this.getTrads();
      }
    });
  }

  getFilesCourrier(): void {
    if (localStorage.getItem('iDelibe_duplicateFileFromiCourrier') === 'true') {
      const icourrierID = +localStorage.getItem('iDelibe_icourrier_id_send');
      this.api.getIcourrierFiles(icourrierID).subscribe((res: any) => {
        this.files = res;
        this.files.map((x) => {
          x.import = true;
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.pointId) {
      this.pointId = changes?.pointId?.currentValue;
    }
  }

  //* method that will get the translations
  getTrads(): void {
    this.fileUploadChooseLabel = this.translater.translate('btn.choose');
    this.fileUploadUploadLabel = this.translater.translate('btn.upload');
    this.fileUploadCancelLabel = this.translater.translate('btn.cancel');
    this.columnsFiles = [
      {
        field: 'description',
        header: this.translater.translate('description'),
        format: (_, item) => {
          if (item && item.description) {
            return item.description;
          } else {
            return item.name;
          }
        },
      },
      {
        field: 'extension',
        header: this.translater.translate('extension'),
      },
      {
        field: 'version',
        header: 'version',
      },
      {
        field: 'statut',
        header: 'statut',
        format: (_, item) => {
          if (item?.iSignSignature?.iSignStatus === 1) {
            return `<div class='status-orange'><i class="bi bi-vector-pen"></i> En cours</div>`;
          } else if (item?.iSignSignature?.iSignStatus === 2) {
            return `<div class='status-green'><i class="bi bi-vector-pen"></i> Signé</div>`;
          } else if (item?.iSignSignature?.iSignStatus === 3) {
            return `<div class='status-red'><i class="bi bi-vector-pen"></i> Refusé</div>`;
          } else if (item?.iSignSignature?.iSignStatus === 4) {
            return `<div class='status-red'><i class="bi bi-vector-pen"></i> Erreur</div>`;
          } else {
            return '-';
          }
        },
      },
      {
        field: 'apercu',
        header: this.translater.translate('preview'),
        format: (_, item) => {
          if (item.extension.toLowerCase() === 'pdf') {
            return '<i class="fas fa-eye"></i>';
          }
        },
        click: (value) => {
          if (value.extension.toLowerCase() === 'pdf') {
            this.openPreviewFile(value);
          }
        },
      },
      {
        field: 'fileType',
        header: this.translater.translate('fileType'),
        format: (_, item) => {
          if (item.modeleId && item.extension.toLowerCase() === 'pdf') {
            return this.translater.translate('document');
          } else if (item.annexeNumero) {
            return this.translater.translate('annexN°') + ' ' + item.annexeNumero;
          } else {
            return this.translater.translate('associatedFile');
          }
        },
      },
      {
        field: 'ordreAffichage',
        header: this.translater.translate('order'),
      },
      {
        field: 'dateUpload',
        header: this.translater.translate('addDateOrGenerationDate'),
        format: (value) => {
          const date = moment(value).isValid() ? moment(value).format('DD/MM/YYYY HH:mm') : '';
          return date;
        },
      },
    ];
    this.getRights();
  }

  //* Will the the user's rights to do actions on the files
  getRights() {
    if (this.globalElement.configApp.delibConfig.isiDelibeMandatairesEnabled) {
      this.actions.push({
        label: 'Mandataire',
        tooltip: 'Mandataire',
        items: [
          {
            label: this.translater.translate('makeVisible'),
            tooltip: this.translater.translate('makeVisible'),
            command: () => {
              this.spinner.show();
              const data = [];
              this.superTableFiles._selection.map((file) => {
                const temp = this.files.find((x) => x.id === file.id);
                temp.fileId = file.id;
                temp.visibleDelibeWeb = true;
                data.push(temp);
              });
              if (this.meeting) {
                this.api.patchSeancesFile(this.meeting.id, data).subscribe(() => {
                  this.toastr.success(this.translater.translate('success.modifiedFiles'));
                  this.emitSuccessUpload.emit(true);
                });
              } else if (this.pointId) {
                this.api.patchPointsFile(this.pointId, data).subscribe(() => {
                  this.toastr.success(this.translater.translate('success.modifiedFiles'));
                  this.emitSuccessUpload.emit(true);
                });
              }
            },
          },
          {
            label: this.translater.translate('makeInvisible'),
            tooltip: this.translater.translate('makeInvisible'),
            command: () => {
              this.spinner.show();
              const data = [];
              this.superTableFiles._selection.map((file) => {
                const temp = this.files.find((x) => x.id === file.id);
                temp.fileId = file.id;
                temp.visibleDelibeWeb = false;
                data.push(temp);
              });
              if (this.meeting) {
                this.api.patchSeancesFile(this.meeting.id, data).subscribe(() => {
                  this.toastr.success(this.translater.translate('success.modifiedFiles'));
                  this.emitSuccessUpload.emit(true);
                });
              } else if (this.pointId) {
                this.api.patchPointsFile(this.pointId, data).subscribe(() => {
                  this.toastr.success(this.translater.translate('success.modifiedFiles'));
                  this.emitSuccessUpload.emit(true);
                });
              }
            },
          },
        ],
      });
      this.columnsFiles.push({
        field: 'visibleDelibeWeb',
        header:
          this.translater.translate('webVisibility._') + ' ' + this.translater.translate('webVisibility.mandataire'),
        format: (value) => {
          if (value) {
            return `<b style="color: #07E299;"><i class="bi bi-check-circle-fill"></i></b>`;
          } else {
            return `<b style="color: #FF5671;"><i class="bi bi-x-circle-fill"></i></b>`;
          }
        },
      });
    }
    if (this.globalElement.configApp.delibConfig.isiDelibeCitoyensEnabled) {
      this.actions.push({
        label: 'Citoyen',
        tooltip: 'Citoyen',
        items: [
          {
            label: this.translater.translate('makeVisible'),
            tooltip: this.translater.translate('makeVisible'),
            command: () => {
              this.spinner.show();
              const data = [];
              this.superTableFiles._selection.map((file) => {
                const temp = this.files.find((x) => x.id === file.id);
                temp.fileId = file.id;
                temp.visibleDelibeWebCitoyen = true;
                data.push(temp);
              });
              if (this.meeting) {
                this.api.patchSeancesFile(this.meeting.id, data).subscribe(() => {
                  this.toastr.success(this.translater.translate('success.modifiedFiles'));
                  this.emitSuccessUpload.emit(true);
                });
              } else if (this.pointId) {
                this.api.patchPointsFile(this.pointId, data).subscribe(() => {
                  this.toastr.success(this.translater.translate('success.modifiedFiles'));
                  this.emitSuccessUpload.emit(true);
                });
              }
            },
          },
          {
            label: this.translater.translate('makeInvisible'),
            tooltip: this.translater.translate('makeInvisible'),
            //* triggers when the user deletes files
            command: () => {
              this.spinner.show();
              const data = [];
              this.superTableFiles._selection.map((file) => {
                const temp = this.files.find((x) => x.id === file.id);
                temp.fileId = file.id;
                temp.visibleDelibeWebCitoyen = false;
                data.push(temp);
              });
              if (this.meeting) {
                this.api.patchSeancesFile(this.meeting.id, data).subscribe(() => {
                  this.toastr.success(this.translater.translate('success.modifiedFiles'));
                  this.emitSuccessUpload.emit(true);
                });
              } else if (this.pointId) {
                this.api.patchPointsFile(this.pointId, data).subscribe(() => {
                  this.toastr.success(this.translater.translate('success.modifiedFiles'));
                  this.emitSuccessUpload.emit(true);
                });
              }
            },
          },
        ],
      });
      this.columnsFiles.push({
        field: 'visibleDelibeWebCitoyen',
        header: this.translater.translate('webVisibility._') + ' ' + this.translater.translate('webVisibility.citoyen'),
        format: (value) => {
          if (value) {
            return '<b style="color: #07E299;"><i class="bi bi-check-circle-fill"></i></b>';
          } else {
            return `<b style="color: #FF5671;"><i class="bi bi-x-circle-fill"></i></b>`;
          }
        },
      });
    }
  }

  //* Will trigger on click of the ... row button
  receive_menu_Files(event) {
    this.fileClicked = new CustomFile(event);
  }

  //* Will verify if the selected file is a PDF or not for it to be considered as an annex
  public isAnnexReadonly() {
    const ext = this.fileClicked?.extension.toLowerCase();
    if (ext !== 'pdf') {
      return true;
    } else {
      return false;
    }
  }

  //* triggers when the user uploads files
  onUpload(event, uploader) {
    async.waterfall([
      (cb) => {
        this.confirmDialogBool = true;
        cb(null);
      },
      () => {
        this.itemsUploaded = event.files;
        this.uploader = uploader;
      },
    ]);
  }

  addFileAnnexe(isAnnexeFile: boolean) {
    async.waterfall([
      (cb) => {
        this.spinner.show();
        this.count = 0;
        const totalItems = this.itemsUploaded.length;
        for (const file of this.itemsUploaded) {
          file.description = file.name;
          file.extension = file.name.split('.').pop();
          file.date = moment(file.lastModifiedDate, 'DD/MM/YYYY');
          file.pointId = this.pointId;
          const isPDF = file.extension.toLowerCase() === 'pdf' ? true : false;
          const document = {
            description: file.name,
            version: 1,
          };
          if (this.meeting) {
            this.api
              .addSeanceFiles(this.meeting.id, document, file, file.extension, isPDF ? isAnnexeFile : false)
              .subscribe(
                (response) => {
                  this.files.push(new CustomFile(response));
                  this.count++;
                  if (this.count === totalItems) {
                    cb(null);
                  }
                },
                (error) => {
                  console.error(error);
                  this.spinner.hide();
                  this.toastr.error("Une erreur est survenue lors de l'ajout du fichier : " + file.description);
                }
              );
          } else if (this.pointId) {
            this.api.addPointFiles(this.pointId, document, file, file.extension, isAnnexeFile).subscribe(
              (response) => {
                this.files.push(new CustomFile(response));
                this.count++;
                if (this.count === totalItems) {
                  cb(null);
                }
              },
              (error) => {
                console.error(error);
                this.spinner.hide();
                this.toastr.error("Une erreur est survenue lors de l'ajout du fichier : " + file.description);
              }
            );
          }
        }
      },
      (cb) => {
        this.itemsUploaded = null;
        this.toastr.success('Merci', 'Les fichiers ont été enregistrés!');
        this.spinner.hide();
        this.uploader.clear();
        this.emitSuccessUpload.emit(true);
        this.confirmDialogBool = false;
        cb(null);
      },
    ]);
  }

  public deleteSelectionFiles(items) {
    this.spinner.show();
    let count = 0;
    async.waterfall([
      (cb) => {
        if (items && items.length > 0) {
          items.map((item) => {
            if (this.meeting) {
              this.api.deleteSeanceFile(this.meeting.id, item.id).subscribe(() => {
                this.toastr.success(this.translater.translate('success.deletedPointFile', { item: item.description }));
                count = count + 1;
                if (count === items.length) {
                  cb(null);
                }
              });
            } else if (this.pointId) {
              this.api.deletePointFile(this.pointId, item.id).subscribe(() => {
                this.toastr.success(this.translater.translate('success.deletedPointFile', { item: item.description }));
                count = count + 1;
                if (count === items.length) {
                  cb(null);
                }
              });
            }
          });
        }
      },
      () => {
        this.spinner.hide();
        this.emitSuccessUpload.emit(true);
      },
    ]);
  }

  //* Triggers when the user download a file (on the row click of a file)
  downloadFile(event) {
    if (this.fileRights.files.open) {
      if (this.meeting) {
        this.api.downloadSeanceFile(this.meeting.id, event.id).subscribe((res: any) => {
          const downloadURL = URL.createObjectURL(res);
          if ((event.description || event.name) && event.extension) {
            saveAs(downloadURL, (event.description ? event.description : event.name) + '.' + event.extension);
          } else {
            this.toastr.error("Impossible de sauver le fichier, il n'y a pas de nom ou d'extension");
          }
        });
      } else if (this.pointId) {
        this.api.downloadPointFile(this.pointId, event.id).subscribe((res: any) => {
          const downloadURL = URL.createObjectURL(res);
          if ((event.description || event.name) && event.extension) {
            saveAs(downloadURL, (event.description ? event.description : event.name) + '.' + event.extension);
          } else {
            this.toastr.error("Impossible de sauver le fichier, il n'y a pas de nom ou d'extension");
          }
        });
      }
    }
  }

  //* triggers when the user confirms the modification of a file (inside the modal used for)
  submitModificationFile() {
    if (this.formFilesModification.valid) {
      let indexOfAnnexIdentique;
      let annexDoesntAlreadyExistInFiles = false; //le flag va permettre de déterminer si l'annexe possède un numéro identique a une autre existante
      const allPointFiles = this.files.filter((x) => x.id !== this.formFilesModification.value.id);
      if (this.formFilesModification.value.annexeNumero) {
        const allAnnexNumbers = allPointFiles.map((x) => {
          return x.annexeNumero;
        });
        indexOfAnnexIdentique = allAnnexNumbers.indexOf(this.formFilesModification.value.annexeNumero);
        if (indexOfAnnexIdentique > -1) {
          annexDoesntAlreadyExistInFiles = false;
        } else {
          //si c'est === -1 alors on a pas d'intersection et donc pas d'annexe avec le même numéro
          annexDoesntAlreadyExistInFiles = true;
        }
      } else {
        annexDoesntAlreadyExistInFiles = true; //Pas de n° d'annexe donc c'est ok
      }

      if (annexDoesntAlreadyExistInFiles) {
        const data = this.formFilesModification.value;

        if (!data.annexe) {
          data.annexeNumero = null;
        }

        if (!this.globalElement.configApp.delibConfig.isiDelibeMandatairesEnabled) {
          delete data.visibleDelibeWeb;
        }
        if (!this.globalElement.configApp.delibConfig.isiDelibeCitoyensEnabled) {
          delete data.visibleDelibeWebCitoyen;
        }
        if (this.meeting) {
          this.api.patchSeanceFile(this.meeting.id, this.formFilesModification.value.id, data).subscribe(() => {
            this.openModification = false;
            this.toastr.success(this.translater.translate('success.modifiedFile'));
            this.emitSuccessUpload.emit(true);
          });
        } else if (this.pointId) {
          this.api.patchPointFile(this.pointId, this.formFilesModification.value.id, data).subscribe(() => {
            this.openModification = false;
            this.toastr.success(this.translater.translate('success.modifiedFile'));
            this.emitSuccessUpload.emit(true);
          });
        }
      } else {
        this.toastr.error(
          allPointFiles[indexOfAnnexIdentique].description + ' ' + this.translater.translate('error.sameAnnexNumber')
        );
      }
    } else {
      this.toastr.error(this.translater.translate('error.pleaseCompleteMandatoryFields'));
    }
  }

  //* Method that will retrieve the translation for the toolitp displayed
  public getTooltipContent() {
    const data = this.translater.translate('ifNotPDFThenAssociatedFile');
    return data;
  }

  //* Will set the required state of annexeNumero if the file's set as an annex
  public changeTypeOfFileInModification(event) {
    if (event.checked === true) {
      if (this.formFilesModification.controls['annexeNumero']) {
        this.formFilesModification.controls['annexeNumero'].setValidators([Validators.required]);
        this.formFilesModification.controls['annexeNumero'].updateValueAndValidity();
      }
    } else {
      this.formFilesModification.controls['annexeNumero'].clearValidators();
      this.formFilesModification.controls['annexeNumero'].updateValueAndValidity();
    }
  }

  openPreviewFile(item): void {
    this.pdfViewerConfig = this.iViewerService.initializePdfViewerConfig();
    if (item && item.id) {
      this.api[this.meeting ? 'downloadSeanceFile' : 'downloadPointFile'](
        this.meeting ? this.meeting.id : this.pointId,
        item.id
      ).subscribe((res: any) => {
        this.blobViewer = URL.createObjectURL(res);
        // Créer l'objet une seule fois
        this.currentFileForViewer = this.iViewerService.getFileFromBlob(this.blobViewer);
        this.modalPdfViewer = true;
      });
    }
  }

  openMenu(event) {
    this.filesMenu = [{}];
    if (event.modeleId !== null) {
      this.filesMenu = [
        {
          label: this.translater.translate('btn.modifyGenerated'),
          command: (item) => {
            this.currentFileToOpen = item;
            // localStorage.setItem('openFromFilesTable','true');
            if (this.meeting) {
              window.open(
                this.globalConfig.baseUrl +
                  '/private/editor/documentmodel/' +
                  this.currentFileToOpen.modeleId +
                  '/seanceId/' +
                  this.meeting.id.toString() +
                  '?generatedAndSaved=' +
                  true,
                '_blank'
              );
            } else if (this.pointId) {
              window.open(
                this.globalConfig.baseUrl +
                  '/private/editor/documentmodel/' +
                  this.currentFileToOpen.modeleId +
                  '/pointId/' +
                  this.pointId.toString() +
                  '?generatedAndSaved=' +
                  true,
                '_blank'
              );
            }
          },
        },
      ];
    } else {
      this.filesMenu = [
        {
          label: this.translater.translate('btn.modify'),
          command: () => {
            window.setTimeout(() => {
              this.openModification = true;
              const index = this.files.map((x) => x.id).indexOf(this.fileClicked.id);
              this.selectedFile = this.files[index];
              this.formFilesModification.patchValue({
                id: this.selectedFile.id,
                description: this.selectedFile.description,
                annexeNumero: this.selectedFile.annexeNumero,
                OrdreAffichage: this.selectedFile.ordreAffichage,
                annexe:
                  this.selectedFile.extension === 'pdf' && !this.selectedFile.modeleId
                    ? this.selectedFile.annexeNumero
                      ? true
                      : false
                    : false,
                visibleDelibeWeb: this.selectedFile.visibleDelibeWeb,
                visibleDelibeWebCitoyen: this.selectedFile.visibleDelibeWebCitoyen,
              });
            }, 500);
          },
        },
      ];
    }
  }

  private canUpload(files: FileList | File[]): boolean {
    if (!files.length) return false;

    if (Array.from(files).some((file) => FileUtil.exceedsSize(file, this.maxFileSize))) {
      this.toastr.error(this.translater.translate('error.invalidFileSizeMessage3'), `Fichier trop large`);
      return false;
    }

    const sumSizes = Array.from(files).reduce((acc, file) => acc + file.size, 0);

    if (sumSizes > this.MaxFilesSize) {
      this.toastr.error(
        this.translater.translate('error.invalidFileSizeMessage3'),
        'La somme totale de la taille des fichiers dépasse la taille maximum autorisée'
      );
      return false;
    }

    return true;
  }

  public onFilesUploaded(event: FileSelectEvent, asAnnexe: boolean): void {
    if (!this.canUpload(event.currentFiles)) return;

    this.uploadFile(event.currentFiles, asAnnexe);
  }

  public onFileDropped(dropEvent: AreaDropEvent): void {
    const { files, areaIdentifier } = dropEvent;

    if (!this.canUpload(files)) return;

    this.uploadFile(Array.from(files), areaIdentifier !== 1);
  }

  uploadFile(files: File[], isAnnexe: boolean): void {
    this.spinner.show();

    if (this.meeting) {
      this.api.addSeanceFilesMultiple(this.meeting.id, files, isAnnexe).subscribe(
        () => {
          this.toastr.success(this.translater.translate('success.addFile'));
          this.emitSuccessUpload.emit(true);
          this.spinner.hide();
        },
        (error) => {
          console.error('error ==>', error);
          this.toastr.error(error.error.message || 'An error occurred while uploading the file');
          this.spinner.hide();
        }
      );
    } else if (this.pointId) {
      this.api.addPointFilesMultiple(this.pointId, files, isAnnexe).subscribe(
        () => {
          this.toastr.success(this.translater.translate('success.addFile'));
          this.emitSuccessUpload.emit(true);
          this.spinner.hide();
        },
        (error) => {
          console.error('error ==>', error);
          this.toastr.error(error.error.message || 'An error occurred while uploading the file');
          this.spinner.hide();
        }
      );
    }
  }

  public getFileFromBlob(): IFile | null {
    return this.iViewerService.getFileFromBlob(this.blobViewer);
  }
}
